'use client'

import {
  Avatar,
  Button,
  Container,
} from "@mui/material";
import Check from "@mui/icons-material/Check";
import React from "react";
import NextLink from "next/link";
import { theme, MyPaper } from "@/styles/theme";
import { INoticeProps } from "@/interfaces/NoticeProps";
import { useTranslation } from "react-i18next";

export default function Notice({ message }: INoticeProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Container component="main" maxWidth="md">
        <MyPaper>
          <Avatar>
            <Check />
          </Avatar>
          {message}
          <Button
            href="/"
            // fullWidth
            variant="contained"
            color="primary"
            sx={{ margin: theme.spacing(3, 0, 2), padding: theme.spacing(1, 8, 1, 8) }}
            LinkComponent={NextLink}
          >
            {t('common:home')}
          </Button>
        </MyPaper>
      </Container>
  );
}
